import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EReminderSeriesFrequency,
  TReminderSeries,
} from 'src/app/project/modules/reminders/reminders.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';

@Component({
    selector: 'pp-point-reminder-modal-recurring-options',
    templateUrl: './point-reminder-modal-recurring-options.component.html',
    styleUrl: './point-reminder-modal-recurring-options.component.scss',
    standalone: false
})
export class PointReminderModalRecurringOptionsComponent {
  @Input() ppSeries: TReminderSeries;
  @Output() ppSeriesChange: EventEmitter<TReminderSeries> = new EventEmitter<TReminderSeries>();
  @Input() set ppMinDate(date: Date) {
    this.date = date;
    this.day = date.getDate();
    this.checkIsSeriesMissingDates();
  }
  @Input() ppDisabled = false;
  @Output() ppScrollToBottom: EventEmitter<void> = new EventEmitter<void>();

  EIconPath = EIconPath;
  showWarningMessage = false;

  date: Date;
  day: number;

  onSeriesChange(): void {
    this.ppSeriesChange.emit(this.ppSeries);
    this.checkIsSeriesMissingDates();
  }

  checkIsSeriesMissingDates(): void {
    if (!this.ppSeries) {
      return;
    }
    this.showWarningMessage =
      (this.day && this.day > 28 && this.ppSeries.frequency === EReminderSeriesFrequency.MONTHLY) ||
      (this.ppSeries.frequency === EReminderSeriesFrequency.YEARLY &&
        this.day === 29 &&
        this.date.getMonth() === 1);
  }

  onScrollToBottom(): void {
    this.ppScrollToBottom.emit();
  }
}
